module.exports = __webpack_public_path__ + "img/gitee.231c824d.svg";